var map = {
	"./auth.js": "UBnP",
	"./buildings.js": "2g4h",
	"./group.js": "Kp8Z",
	"./locations.js": "p9jI",
	"./lookup.js": "jkSA",
	"./survey.js": "WR7Q",
	"./users.js": "UY+X"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VkOT";


//////////////////
// WEBPACK FOOTER
// ./src/api/endpoints \.js$
// module id = VkOT
// module chunks = 22